module.exports = __webpack_public_path__ + "static/img/4g.54243d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4g.jpg
// module id = 3KXN
// module chunks = 1